<template>
<div class="qn-footer">
  <div class="container">
    <div class="about">
      <div class="title">{{data.title}}</div>
      <div class="description">
        {{data.description}}
      </div>
    </div>
    <div class="qrcode">
      <div class="logo">
        <img :src="data.logo" alt="">
      </div>
      <div class="img-qrcode">
        <img :src="data.qrcode" alt="">
      </div>
      <div class="word">
        <b>{{data.word}}</b>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: [
    'data'
  ],
  data () {
    return {}
  }
}
</script>
<style scoped lang='sass'>

=mobile
  @media screen and (max-width: 768px)
    @content

.qn-footer
  background-color: #000
  padding: 45px 0
  // margin-top: 15px

.container
  display: flex
  justify-content: space-between
  +mobile
    flex-direction: column
  .about
    width: 85%
    +mobile
      width: 100%
    .title
      color: #fff
      font-size: 30px
      font-weight: 700
      margin-bottom: 20px
    .description
      color: #aaabad
      font-size: 14px
  .qrcode
    width: 11%
    +mobile
      width: 30%
      margin-top: 40px
    .img-qrcode
      padding: 5px
      background-color: #fff
      border-radius: 5px
  .logo
    margin-bottom: 10px
    +mobile
      margin-bottom: 20px
    img
      width: 94%
  .word
    text-align: center
    padding-top: 4px
    +mobile
      display: none
    b
      font-size: 14px
</style>



// WEBPACK FOOTER //
// src/components/footer-about/footer.vue